<template>
    <v-card class="list mb-3" min-height="105px" :to="'/'+ getPathLink(item.dsTipo) +'/'+ item.idItem +'/'+ slug(item.dsItem)" >
        <div class="py-3 d-flex align-center">
             <img
                @error="changeImg($event)"
                style="height: 100px; object-fit: cover;"
                :class="item.dsTipo != 'GARRAFA' ? 'maxHeightProduto' : ''"
                :src="
                  $drink_img_uri +
                    '/'+  getPathImg(item.dsTipo) + '/' +
                    item.idItem +
                    '.png'
                " />
        </div>
        <div class="infoProduto d-flex flex-column justify-start py-3" style="width: 100%;">
          <span style="color: #FF8723;">{{item.dsTipo}}</span>
          <span class="my-1" style="font-weight: bold;">{{item.dsItem}}</span>
          <v-row style="width: 100%;">
            <!-- <v-col class="d-flex flex-row align-center pr-0" cols="4">
              <div class="circle d-flex align-center justify-center mr-1" style="width: 30px; height: 30px;">
                  <img src="../img/heat.png" width="20" alt="">
              </div>
              <span>{{produto.dsTeorAlc}}%</span>
            </v-col> -->
            <v-col class="d-flex flex-row align-center pr-0" cols="8">
              <div class="circle d-flex align-center justify-center mr-1" style="width: 30px; height: 30px;"> 
                  <img src="../img/cash.png" width="20" alt="">
              </div>
              <span>{{item.vlDe}} ~ {{item.vlAte}}</span>
            </v-col>
          </v-row>
        </div>
        <div >
          <img src="../img/calculator.png" width="40px">
        </div>
    </v-card>
</template>
<style scoped>
.maxHeightProduto { 
  max-height:60px;
}
</style>
<script>
  import "../css/produto.css";

  export default {
    name: 'CardItem',
    props: {'item': Object, "garrafa": Boolean},
    data: () => ({
    }),
    methods: { 
      changeImg(e) {
        e.target.src = require("../img/drink.png");
      },     
      getPathImg(dsTipo) { 
        return dsTipo === "DRINK" ? 'bebida' :
              dsTipo === "DOSE" ? 'bebida' :
              dsTipo === "RTD" ? 'bebida' : 'garrafa'
      },
      getPathLink(dsTipo) { 
        return dsTipo === "DRINK" ? 'bebida' :
              dsTipo === "DOSE" ? 'bebida' :
              dsTipo === "RTD" ? 'bebida' : 'produto'
      },
      slug: function(title) {
        var slug = "";
        // Change to lower case
        var titleLower = title.toLowerCase();
        // Letter "e"
        slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, "e");
        // Letter "a"
        slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, "a");
        // Letter "o"
        slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, "o");
        // Letter "u"
        slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, "u");
        // Letter "d"
        slug = slug.replace(/đ/gi, "d");
        // Trim the last whitespace
        slug = slug.replace(/\s*$/g, "");
        // Change whitespace to "-"
        slug = slug.replace(/\s+/g, "-");

        return slug;
      },  
    }
  }
</script>

